import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { groupMeta, theme } from '../constants';
import { AlertIcon, ArrowRightIcon, DeviceGlyph } from './Icons';

const Leg = ({ label, house, room = null, muted = false }) => (
  <div style={{ flex: 1, minWidth: 0 }}>
    <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase', color: theme.textFaint }}>
      {label}
    </div>
    <div
      style={{
        fontSize: 13,
        fontWeight: 700,
        color: muted ? theme.textMuted : theme.text,
        marginTop: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {house}
    </div>
    {room && <div style={{ fontSize: 11.5, color: theme.textFaint, marginTop: 1 }}>{room}</div>}
  </div>
);

function ConfirmMoveModal({ open, onClose, devices, fromHouse, toHouse, onConfirm, loading }) {
  const count = devices?.length || 0;
  const soloDevice = count === 1 ? devices[0] : null;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: 14, fontFamily: theme.font } }}
    >
      <DialogTitle sx={{ fontFamily: theme.font, fontWeight: 700, fontSize: 15.5, paddingBottom: 0.5 }}>
        {count > 1 ? `Move ${count} devices?` : 'Move this device?'}
      </DialogTitle>

      <DialogContent sx={{ paddingTop: '8px !important' }}>
        {count > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              maxHeight: 220,
              overflowY: 'auto',
              paddingRight: count > 1 ? 4 : 0,
            }}
          >
            {devices.map((device) => {
              const meta = groupMeta(device.groupKey);
              return (
                <div
                  key={device.deviceId}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 11,
                    padding: '11px 13px',
                    borderRadius: 10,
                    border: `1px solid ${theme.border}`,
                    background: theme.surfaceMuted,
                  }}
                >
                  <span
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 9,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: meta.bg,
                      color: meta.color,
                    }}
                  >
                    <DeviceGlyph groupKey={device.groupKey} size={16} />
                  </span>
                  <span style={{ minWidth: 0 }}>
                    <span
                      style={{
                        display: 'block',
                        fontSize: 13.5,
                        fontWeight: 700,
                        color: theme.text,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {device.name}
                    </span>
                    <span style={{ display: 'block', fontSize: 11.5, color: theme.textFaint }}>
                      {meta.label} · {device.deviceId}
                    </span>
                  </span>
                </div>
              );
            })}
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '14px 0 4px' }}>
          <Leg label="From" house={fromHouse} room={soloDevice?.roomName || '—'} muted />
          <span style={{ color: theme.accent, flexShrink: 0, display: 'flex' }}>
            <ArrowRightIcon size={18} />
          </span>
          <Leg label="To" house={toHouse} />
        </div>

        <div
          style={{
            display: 'flex',
            gap: 9,
            marginTop: 16,
            padding: '10px 12px',
            borderRadius: 9,
            background: 'rgba(245,158,11,0.08)',
            border: '1px solid rgba(245,158,11,0.25)',
          }}
        >
          <span style={{ color: '#b45309', flexShrink: 0, display: 'flex', marginTop: 1 }}>
            <AlertIcon size={15} />
          </span>
          <span style={{ fontSize: 12, color: '#92400e', lineHeight: '17px' }}>
            Schedules and automations that reference {count > 1 ? 'these devices' : 'this device'} on the current
            property will stop applying to {count > 1 ? 'them' : 'it'}.
          </span>
        </div>
      </DialogContent>

      <DialogActions sx={{ padding: '10px 20px 16px' }}>
        <button
          onClick={onClose}
          disabled={loading}
          style={{
            padding: '8px 20px',
            border: `1px solid ${theme.border}`,
            borderRadius: 8,
            background: theme.surface,
            color: theme.textMuted,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: theme.font,
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          style={{
            padding: '8px 22px',
            border: 'none',
            borderRadius: 8,
            background: loading ? '#93a3d8' : 'rgba(32,80,255,0.9)',
            color: '#fff',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: theme.font,
            fontSize: 13,
            fontWeight: 700,
            transition: 'background 0.2s',
          }}
        >
          {loading ? 'Moving…' : 'Confirm Move'}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmMoveModal;
